import { Modal } from 'antd'
import DocLinkToForm from '../../../../components/Common/Documents/Modal/DocLinkToForm'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import React from 'react'

function DocLinkToModal(props) {
  const { visible, submitting, formRef, onCancel, isNew, submit } = props

  return (
    <Modal
      visible={visible}
      title={'Create Cargo'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={<FooterButtons submit={submit} submitting={submitting} title={'Create Cargo'} isNew={isNew} />}
      width={'75%'}>
      <DocLinkToForm ref={formRef} {...props} />
    </Modal>
  )
}

export default DocLinkToModal
